module.exports = __webpack_public_path__ + "media/promo/courses/images/s5-29149ce02a3c4ebea1aed947ad0a826f.jpg";